import React, {memo} from 'react';
import {connect} from 'react-redux';
import Edge from './Edge.js';

const Edges = memo(({edges, rack, setSelectedEdge, selectedEdge, startDrawingEdge, stepNumber, playing}) => {
    let inputEdges = edges[-1] || [];
    let list = [];
    for (let i in rack.effects) {
        let effect = rack.effects[i];
        let effectEdges = edges[effect.id];
        if (effectEdges === undefined) {
            continue;
        }
        list = [... list,
                ... effectEdges.map(
                    (edge, i) =>
                        <Edge
                          triggerCount={edge.triggerCount}
                          playing={playing}
                          effect={effect}
                          key={"input-edge- " + i + '-' + effect.id}
                          startDrawingEdge={startDrawingEdge}
                          edge={edge}
                          rack={rack}
                          setSelectedEdge={setSelectedEdge}
                          selected={selectedEdge === edge}/>
                )];
    }

    return (
        <g>
          {inputEdges.map(
              (edge, i) =>
                  <Edge
                        key={"edge- " +i}
                        effect={rack.inputNode}
                        startDrawingEdge={startDrawingEdge}
                        edge={edge}
                        rack={rack}
                        setSelectedEdge={setSelectedEdge}
                        selected={selectedEdge === edge}
                    />)}
        {list}
        </g>
    );
});

const mapStateToProps = (state, props) => {
    return {
        stepNumber: props.isMidiEffect ? props.rack.sequencerEngine.trackStep : 0,
        playing: props.rack.sequencerEngine.playing
    };
};

export default connect(mapStateToProps, null)(Edges);
